"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditworthinessToJSON = exports.CreditworthinessFromJSONTyped = exports.CreditworthinessFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CreditworthinessFromJSON(json) {
    return CreditworthinessFromJSONTyped(json, false);
}
exports.CreditworthinessFromJSON = CreditworthinessFromJSON;
function CreditworthinessFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'creditworthy': json['creditworthy'],
        'address': !(0, runtime_1.exists)(json, 'address') ? undefined : (0, _1.AddressFromJSON)(json['address']),
    };
}
exports.CreditworthinessFromJSONTyped = CreditworthinessFromJSONTyped;
function CreditworthinessToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'creditworthy': value.creditworthy,
        'address': (0, _1.AddressToJSON)(value.address),
    };
}
exports.CreditworthinessToJSON = CreditworthinessToJSON;
//# sourceMappingURL=Creditworthiness.js.map